import { useEffect } from "react";
import { Navigation } from "../../components/Navigation/navigation";
import { TeamMember } from "../../components/TeamMember/TeamMember";
import './about.css';
export const About = ( props ) => {
    useEffect(()=>{
        document.querySelector("body#ruby-rock-app").scrollTop = 0;
    },[])
    return (
        <>
        <Navigation />
        <div id="about" className='text-center'>
            <div className='container'>
                <div className='section-title'>
                    <h2>Specimen Labs</h2>
                    <div className="about-text">
                        <p>Specimen Labs is a digital asset development and investment company with focus on asset-backed Tokens and NFTs (real asset tokenization).  We bridge between digital assets and real assets by introducing traditional real assets that are typically illiquid to blockchain technology though the creation of innovative, secured, efficient and transparent tokenized asset.</p>
                    </div>
                    <h2 id="team">Our Team</h2>
                    <div id="team-container">
                        <TeamMember name="Denis Juston-Coumat" title="Founder"/>
                        <TeamMember name="Roy Ceder-Franco" title="Founder"/>
                        <TeamMember name="Sacha Gordillo" title="Founder"/>
                        <TeamMember name="Vitalie Postu" title="Founder"/>
                        <TeamMember name="Carlos Girón de Velasco" title="Project Coordinator"/>
                        <TeamMember name="Rafael Rodríguez" title="Smart Contract Developer"/>
                        <TeamMember name="Mauricio García de Ceca" title="Web Developer"/>
                        <TeamMember name="Francisco Estrella" title="Tech Advisor"/>
                        <TeamMember name="Jorge Castro" title="Tech Advisor"/>
                        <TeamMember name="TurnkeyTown" title="Marketing Strategy"/>
                        <TeamMember name="Elena Rascón" title="NFT Designer"/>
                        <TeamMember name="Md Shaheen Hossen" title="Web Designer"/>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}